<template>
	<page>
		<module enable-flex :tabs="tabs" @tabChange="tabHandle">
			<m-search ref="search" @search="searchHandle">
                <m-search-item label="订单编号">
                    <c-input name="order_number"></c-input>
                </m-search-item>
				<m-search-item label="服务名称">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="买家">
					<c-input name="user_info" placeholder="昵称或手机号"></c-input>
				</m-search-item>
                <!-- <m-search-item label="收货信息">
                    <c-input name="receiving_info"></c-input>
                </m-search-item> -->
				<m-search-item label="下单时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
				</m-search-item>
				<!-- <m-search-item label="订单类型" colspan="2">
					<c-checkbox-group name="order_type" :options="orderType"></c-checkbox-group>
				</m-search-item> -->
				<m-search-item label="订单服务类型" colspan="2" v-if="systemConfig.is_virtual_product == 'ON'">
					<c-checkbox-group name="order_classify" :options="orderClassify"></c-checkbox-group>
				</m-search-item>
			</m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>
            </m-operate>
			<c-table ref="table" height="grow">
				<c-table-column
					width="400"
				>
					<template slot="head">
						<!-- <c-checkbox></c-checkbox> -->
						<span style="margin-left: 15px;">服务信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="单价"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="数量"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="总金额"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="交易状态"
					width="170"
					align-center
				></c-table-column>

				<c-table-column
					label="服务进度/状态"
					width="170"
					align-center
				></c-table-column>

				<c-table-column
					label="操作"
					width="170"
					align-center
                    v-if="userInfo.operation_mode == 2 && userInfo.stationed_type == 2"
				></c-table-column>
				
				<template #custom="{data}">
					<div :key="data.id" class="order">
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<span class="number">订单号：{{data.order_number}}</span>
								<div class="tag" v-if="data.is_retail == 1" style="background:red">分销</div>
								<div class="tag" v-if="data.order_classify == 1  && systemConfig.is_virtual_product == 'ON'" style="background: #00B2FB">{{orderClassifyName[data.order_classify]}}</div>
								<div class="tag" v-if="data.order_classify == 2  && systemConfig.is_virtual_product == 'ON'" style="background: #FFDE00;color:#000;">{{orderClassifyName[data.order_classify]}}</div>
								<div v-if="data.order_type!=1" class="tag" style="background: #4686e0">
                                    {{orderTypeName[data.order_type]}}
                                </div>
								<p class="info">下单时间：{{data.create_date}}</p>
								<p class="info">支付时间：{{data.payment_date}}</p>
							</div>
						</div>
                        <div class="order-head flex-between-center">
                            <div class="flex-center">
                                <span class="number">会员：{{data.nick_name}}&nbsp;| &nbsp;服务区域：{{data.receiving_address}}</span>
								<span v-if="data.prof_agency_state != 0 && (data.payment_state == 2 || data.payment_state == 3 ) && data.order_state != 6">&nbsp;| &nbsp;
									<span v-if="data.prof_agency_state == 1" style="color:blue;">待邀请专业代理</span>
									<span v-else-if="data.prof_agency_state == 2" style="color: orange;">等待专业代理（{{data.prof_nick_name}}）接单</span>
									<span v-else-if="data.prof_agency_state == 3" style="color:red;">专业代理（{{data.prof_nick_name}}）拒绝接单</span>
									<span v-else-if="data.prof_agency_state == 4" style="color:green;">专业代理（{{data.prof_nick_name}}）已接单</span>
								</span>
                            </div>
                        </div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
										<div class="flex-grow">
                                            <p class="sku-name ellipsis">
                                                <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                                {{sku.product_name}}
                                            </p>
                                            <!-- <p class="sku-sku"><span style="color: darkgray">规格：</span>{{sku.product_sku_spec}}</p> -->
                                            <!-- <p class="sku-sku" v-if="sku.product_sku_code"><span style="color: darkgray">SKU编码：</span>{{sku.product_sku_code}}</p> -->
										</div>
									</div>
									<div class="sku-price">
                                        <span v-if="data.product_money">
                                            ￥{{parseFloat(data.product_money).toFixed(2)}}
                                        </span>
                                        <span v-else>--</span>
                                    </div>
									<div class="sku-count">{{sku.product_count}}</div>
								</div>
							</div>
							<div class="order-sum flex-column flex-center">
								<span v-if="data.product_money">
                                    ￥{{parseFloat(data.product_money).toFixed(2)}}
								</span>
							</div>
							<div class="order-state flex-column flex-center">
								<span v-if="data.order_state!=6 && data.check_state == 1 && data.payment_state != 1">
                                    <span style="color: brown">待审核(现金支付)</span>
                                </span>
								<span v-else-if="data.order_state!=6 && data.check_state == 1 && data.payment_state == 1">
                                    <span style="color: brown">
                                        待审核(待报价)
                                    </span>
                                </span>
								<span v-else>
                                    {{orderStateName[data.order_state]}}
                                </span>
								<span v-if="data.refund_flag > 0" style="color: red">
                                    (退款中)
                                </span>
                                <a @click="navigateTo(`/order_detail/${data.order_number}`)">订单详情</a>
							</div>
							<div class="order-state flex-column flex-center">
								<span v-if="(data.order_state == 3||data.order_state == 4) && data.check_state == 2 && data.order_flow_info">
                                    {{data.order_flow_info.flow_name}}
                                    (
                                        <span style="color: darkgrey">{{flowStateName[data.order_flow_info.flow_state]}}</span>
                                    )
                                </span>
                                <span v-else>-</span>
							</div>
							<div class="order-handle flex-column flex-center" v-if="userInfo.operation_mode == 2 && userInfo.stationed_type == 2">
								<c-button v-if="data.operation_mode == 2 && data.check_state==1 && data.order_state != 0 && data.order_state != 6 && userInfo.stationed_type == 2" color="main" @click="navigateTo(`/order_detail/${data.order_number}`)">审批</c-button>
								<c-button v-if="auth('b_order_refund_apply') && data.operation_mode == 2 && (data.order_type == 1 || data.order_type == 5 || data.order_type == 6) && data.check_state == 2 && data.refund_flag!=1 && data.return_flag!=1 && (data.order_state==2 || data.order_state==3 || data.order_state==5)" @click="navigateTo(`/after_sale_apply/${data.order_number}`)">申请售后</c-button>
								<c-button v-if="auth('b_order_trandfer') && data.operation_mode == 2 && data.check_state == 2 && (data.order_state==2 || data.order_state==3) && data.wait_trandfer==1" @click="trandferOrder(data)">转单</c-button>
							</div>
						</div>
					</div>
				</template>
			</c-table>
		</module>
		<!--订单转单弹窗 -->
		<c-dialog ref="orderTrandfer" :title="'订单【'+this.orderNumber+'】转单'" width="900" button-name="转单" @resolve="orderTrandferHandle">
			<c-table ref="orderTrandferList" :data="trandferList" height="320" :paging="false">
				<c-table-column
					type="selector"
				></c-table-column>

				<c-table-column
					label="服务信息"
					width="300"
				>
                    <template #default="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
				</c-table-column>

				<c-table-column
					label="规格信息"
					name="product_sku_spec"
				></c-table-column>

				<c-table-column
					label="待转单数量"
				>
					<template v-slot="{data}">
						×{{data.product_quantity}}
					</template>
				</c-table-column>

				<c-table-column
					label="转单数量"
					width="150"
				>
					<template v-slot="{data, selected}">
						<c-input v-model="trandferNum[data.product_sku]" type="number" width="100" :limit="[1, data.product_quantity]" :disabled="!selected" style="width:130px;" unit="件"/>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
        <!--修改收货地址弹窗-->
        <order-address-edit ref="orderAddressEdit" @resolve="orderAddressEditResolve"></order-address-edit>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from "@/components/public/product_info.vue";
    import orderAddressEdit from "@/components/service/order_address_edit.vue";

    export default {
		components: {
            orderAddressEdit,
            productInfo
        },
		props: {
			tab: String
		},
		data() {
			return {
                workType:14,
                searchParams:{},
				tabsData: [{
					name: '全部订单'
				}, {
					name: '待审核',
                    order_state:-2,
					param: {
						check_state: [1]
					}
				}, {
					name: '待买家付款',
                    order_state:1,
                    param: {
                        order_state: [1]
					}
				}, {
					name: '待服务',
                    order_state:2,
                    param: {
						order_state: [2]
					}
				}, {
					name: '服务中',
                    order_state:3,
                    param: {
						order_state: [3]
					}
				}, {
					name: '待验收',
                    order_state:4,
                    param: {
						order_state: [4]
					}
				}, {
					name: '交易成功',
                    order_state:5,
					param: {
						order_state: [5]
					}
				}, {
					name: '订单关闭',
                    order_state:6,
                    param: {
						order_state: [6]
					}
				}],
				tabsTotal: [],
				currentTab: {},
				orderStateName: {
					0: '待报价',
					1: '待付款',
					2: '待服务',
					3: '服务中',
					4: '待验收',
					5: '服务完结',
					6: '已关闭',
					12: '服务终止'
				},
				flowStateName: {
					1: '待付款',
					2: '待服务',
					3: '服务中'
				},
                orderTypeName: {
                    1: '普通',
                    2: '积分',
                    3: '赠品',
                    4: '砍价',
                    5: '预定全款',
                    6: '预定定金',
                    7: '定制',
                    8: '拼团',
                    9: '云仓提货',
                    10: '送礼',
                    11: '抽奖'
                },
                orderClassifyName: {
                    1: '实物',
                    2: '虚拟',
                },
                orderClassify:[
                    {name: '实物',value: 1},
                    {name: '虚拟',value: 2}
                ],
				trandferList: [],
				trandferNum: {},
				orderNumber:''
			}
		},
		
		computed: {
			...mapState(['userInfo','systemConfig']),
			
			tabs() {
				return Array.from(this.tabsData, (item, index) => {
					return Object.assign({}, item, {
					 	name: this.tabsTotal[item.order_state] ? `${item.name}(${this.tabsTotal[item.order_state]})` : item.name
                    });
				});
			},
			
			orderType() {
				return (
					[{
						name: '普通',
						value: 1
					},{
                        name: '送礼',
                        value: 10
                    },{
                        name: '抽奖',
                        value: 11
                    }].concat(this.systemConfig.points_system == 'ON'?[{
						name: '积分',
						value: 2
					}]:[])
					.concat(this.systemConfig.bargain_enabled == 'ON'?[{
						name: '砍价',
						value: 4
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预定全款',
						value: 5
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预定定金',
						value: 6
					}]:[])
					.concat(this.systemConfig.product_custom == 'ON'?[{
						name: '定制',
						value: 7
					}]:[])
                    .concat([{
                        name: '拼团',
                        value: 8
                    }])
				);
			}
		},
		
		mounted() {
			this.updateTotal();
		},
		
		methods: {
			tabHandle(item) {
				this.currentTab = item;
				this.$refs.search.search();
			},
			
			updateTotal() {
				this.request({
					url: '/order/state/count_list',
					success: data => {
						this.tabsTotal = data;
					}
				});
			},

			searchHandle(data) {
                this.searchParams = Object.assign(data, this.currentTab.param);
                this.$refs.table.load({
					url: '/order/detail_list',
					data: this.searchParams
                });
                this.updateTotal();
			},
            //编辑订单收货地址响应事件处理方法
            orderAddressEditResolve(data){
                //刷新列表
                this.$refs.table.update();
            },
			//发开转单弹窗
			trandferOrder(data){
				this.orderNumber =  data.order_number;
				if(data.order_type == 7){//定制订单
					this.$confirm({
						message: '是否确定对【定制】订单【'+this.orderNumber+'】进行转单？',
						resolve: () => {
							this.request({
								url: '/order/trandfer',
								data: {
									trandfer_type:3,/**3=整单转单  2=部分转单*/
									order_number: this.orderNumber
								},
								loading: true,
								success: data => {
									this.$refs.orderTrandfer.close();
									this.$message({
										message: '转单任务已提交，请在【代发订单】功能中查看转单后的代发订单'
									});
                                    //刷新列表
                                    this.$refs.table.update();
								}
							});
						}
					});
				}else{//非定制
					this.request({
						url: '/order/untrandfer/product/list',
						data: {
							order_number: data.order_number
						},
						loading: true,
						success: data => {
							this.trandferList = data;
							this.$refs.orderTrandfer.open();
							//赋值默认转单数量
							this.trandferList.forEach(item => {
								this.trandferNum[item.product_sku] = item.product_quantity;
							});
						}
					});
				}
			},
			//订单转单
			orderTrandferHandle(stop) {
				var flag = true;
				stop();
				let list = this.$refs.orderTrandferList.getRow('selected');
				if (!list.length) {
					this.$message({
						message: '请选择要转单的服务'
					});
					flag = false;
					return;
				}
				list.forEach(item => {
					if ((parseInt(this.trandferNum[item.data.product_sku]) || 0) <=0){
						this.$message({
							message: '请选择要转单的服务'
						});
						flag = false;
						return;
					}
					if ((parseInt(this.trandferNum[item.data.product_sku]) || 0) > parseInt(item.data.product_quantity)){
						this.$message({
							message: '转单数量不能超过剩余可转数量'
						});
						flag = false;
						return;
					}
				});
				if (flag){
					this.request({
						url: '/order/trandfer',
						data: {
							trandfer_type:2,/**1=整单转单  2=部分转单*/
							order_number: this.orderNumber,
							order_sku_list: Array.from(list, item => {
								return {
									product_sku: item.data.product_sku,
									count: parseInt(this.trandferNum[item.data.product_sku])
								}
							})
						},
						loading: true,
						success: data => {
							this.$refs.orderTrandfer.close();
							this.$message({
								message: '转单任务已提交，请在【代发订单】功能中查看转单后的代发订单'
							});
                            //刷新列表
                            this.$refs.table.update();
						}
					});
				}
			},

            /**同步导出数据**/
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		box-sizing: border-box;
		min-width: 1170px;
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.tag {
				border-radius: 2px;
				padding: 0 5px;
				margin-left: 6px;
				line-height: 18px;
				color: #fff;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 660;
			flex-basis: 660px;
			
			.sku {
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-info {
					flex-grow: 400;
					flex-basis: 400px;
					box-sizing: border-box;
					padding: 10px 0 10px 14px;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 10px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-sku {
					margin-top: 10px;
					font-size: 12px;
				}
				
				&-price,
				&-count {
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 13px;
					text-align: center;
					color: #333;
				}
			}
		}
		
		&-sum,
		&-state,
		&-handle {
			flex-grow: 170;
			flex-basis: 170px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			.c-button {
				width: 6em;
				
				&:nth-child(n+2) {
					margin-top: 8px;
				}
			}
		}
	}
</style>
